module.exports = __webpack_public_path__ + "img/no-access.dcf522e4.svg";